import styled from "styled-components";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { THATS_ALL_IMAGE_DIMENSIONS } from "../../constants";

export const TransitionGroupContainer = styled.div`
    display: flex;
`;

export const ThatsAllContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    flex-shrink: 0;
    align-self: stretch;
    padding-bottom: 0;
    height: 130px;
`;

export const ThatsAllImage = styled(Image).attrs({
    width: String(THATS_ALL_IMAGE_DIMENSIONS.WIDTH),
    height: String(THATS_ALL_IMAGE_DIMENSIONS.HEIGHT),
})`
    margin-bottom: ${(props) => `calc(${props.theme.spacing.xLarge} + ${props.theme.spacing.medium} + 2px)`};
`;
